let loadedFonts = {};
let watchingFonts = {};

export function resetFontState() {
  loadedFonts = {};
  watchingFonts = {};
}

export function isFontReady(fontFamily: string) {
  fontFamily = onlyConsiderFirstFontFamily(fontFamily);
  return !fontFamily || !!loadedFonts[fontFamily];
}

export function waitForFont(fontFamily: string, callback: () => void) {
  fontFamily = onlyConsiderFirstFontFamily(fontFamily);
  let intervalID = 0;
  if (!watchingFonts[fontFamily]) {
    watchingFonts[fontFamily] = [callback];
    intervalID = watchFont(fontFamily);
  } else {
    watchingFonts[fontFamily].push(callback);
  }

  return {
    stop: function cleanUp() {
      const index = watchingFonts[fontFamily].indexOf(callback);
      if (index >= 0) {
        watchingFonts[fontFamily].splice(index, 1);
      }
      if (intervalID && !watchingFonts[fontFamily].length) {
        clearInterval(intervalID);
      }
    },
  };
}

function onlyConsiderFirstFontFamily(font: string) {
  return font && font.split(',')[0];
}

function watchFont(fontFamily: string) {
  const fallbackFont = 'sans-serif';
  const sampleText = 'I hope iFIT! ;)';
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  let intervalID = 0;
  if (!context) {
    doneWaiting(false);
    return 0;
  }
  context.font = '12px ' + fallbackFont;
  const fallbackWidth = context.measureText(sampleText).width;

  context.font = '12px ' + fontFamily + ',' + fallbackFont;
  const waitFor = 3000;
  const checkEvery = 30;
  let remainingTries = waitFor / checkEvery;
  intervalID = window.setInterval(checkFont, checkEvery);
  checkFont();
  return intervalID;

  function checkFont() {
    let newWidth = context?.measureText(sampleText).width || fallbackWidth;

    // iOS 10 doesn't fallback initially, it renders with an odd, very large font.
    // We can detect that, and continue checking to see when it properly loads.
    if (newWidth !== fallbackWidth && newWidth < fallbackWidth * 2) {
      doneWaiting(true);
    } else if (remainingTries > 0) {
      remainingTries -= 1;
    } else {
      doneWaiting(false);
    }
  }

  function doneWaiting(success: boolean) {
    if (intervalID) {
      clearInterval(intervalID);
    }
    loadedFonts[fontFamily] = true;
    watchingFonts[
      fontFamily
    ].forEach((fontFamilyCallback: (bool: boolean) => void) =>
      fontFamilyCallback(success)
    );
    watchingFonts[fontFamily] = [];
  }
}
